import { render } from "./TBoxes.vue?vue&type=template&id=ca0cecb6&scoped=true"
import script from "./TBoxes.vue?vue&type=script&lang=js"
export * from "./TBoxes.vue?vue&type=script&lang=js"

import "./TBoxes.vue?vue&type=style&index=0&id=ca0cecb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0cecb6"]])

export default __exports__